import { ViewEditModeContextProvider } from 'app/context/ViewEditModeContext/ViewEditModeContext';

import { Pack } from '../Common/Pack';

export const PackCreation = () => {
  return (
    <ViewEditModeContextProvider>
      <Pack />
    </ViewEditModeContextProvider>
  );
};
